/* istanbul ignore file */
import ES from './translations/es.json';
import PT from './translations/pt.json';

export const i18n = { ES, PT };
